import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        oauth_token: '',
        user_domain: '',
        user_name: '',
        mac: '',
        dataGroup: []
    },
    mutations: {
        loginsave(state, user) { // 第一个参数为 state 用于变更状态 登录
            sessionStorage.setItem("oauth_token", user.oauth_token);
            sessionStorage.setItem("user_domain", user.user_domain);
            sessionStorage.setItem("dataGroup", user.dataGroup);
            sessionStorage.setItem("user_name", user.user_name);
            sessionStorage.setItem("datas", user.datas);
            sessionStorage.setItem("mac", user.mac);
        },
        loginOut(oauth_token, user_domain) { // 退出登录
            sessionStorage.removeItem("oauth_token", oauth_token);
            sessionStorage.removeItem("user_domain", user_domain);
            sessionStorage.removeItem("dataGroup");
            sessionStorage.removeItem("user_name");
            sessionStorage.removeItem('isNew');
            sessionStorage.removeItem("datas");
            sessionStorage.removeItem("mac");
        },
        loginget() {
            if (window.sessionStorage.getItem("oauth_token") === null) {
                this.$router.push('/');
            }
            else {
                window.sessionStorage.getItem("oauth_token");
                window.sessionStorage.getItem("user_domain");
                window.sessionStorage.getItem("user_name");
                window.sessionStorage.getItem("dataGroup");
                window.sessionStorage.getItem("datas");
                window.sessionStorage.getItem("mac");
            }
        }
    }
});

export default store;
